//@flow

import {makeStyles} from '@material-ui/core';
import React from 'react';
import {colors} from '../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    flexGrow: 1,
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
    },

    '&::-webkit-scrollbar-track': {
      background: colors.grey200,
      borderRadius: '5px',
    },

    '&::-webkit-scrollbar-thumb': {
      background: colors.grey400,
      borderRadius: '5px',
    },
  },
}));

type Props = {
  children: React$Node,
};

export default function SidebarContent({children}: Props) {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
}
